// Power-score bar (0–100) with colour coding and optional label.

import { cn } from './lib/utils.js';

export interface PowerScoreBarProps {
  /** 0–100 score value. */
  readonly score: number;
  /** Optional label shown to the left of the bar. */
  readonly label?: string;
  readonly className?: string;
}

export function PowerScoreBar({ score, label, className }: PowerScoreBarProps) {
  const clamped = Math.max(0, Math.min(100, score));
  const pct = `${clamped}%`;

  return (
    <div className={cn('flex items-center gap-2', className)}>
      {label && <span className="w-20 shrink-0 text-xs text-muted-foreground">{label}</span>}
      <div className="h-2 flex-1 rounded-full bg-muted/40">
        <div
          className={cn('h-full rounded-full transition-all', barColor(clamped))}
          style={{ width: pct }}
        />
      </div>
      <span className="w-7 text-right text-xs tabular-nums text-muted-foreground">{clamped}</span>
    </div>
  );
}

function barColor(score: number): string {
  if (score >= 80) return 'bg-emerald-500';
  if (score >= 50) return 'bg-amber-400';
  if (score >= 25) return 'bg-orange-500';
  return 'bg-red-500';
}
